import React, { useState } from "react";
import { Typewriter } from "react-simple-typewriter";
import SyncLoader from "react-spinners/SyncLoader";
import emailjs from "@emailjs/browser";
import toast, { Toaster } from "react-hot-toast";
import "react-toastify/dist/ReactToastify.css";

import { images } from "../../constants";
import { AppWrap, MotionWrap } from "../../wrapper";
// import { client } from "../../client";
import "./Footer.scss";

const Footer = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [formDataError, setFormDataError] = useState({
    nameError: "",
    emailError: "",
    messageError: "",
  });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const { username, email, message } = formData;

  const handleChangeInput = (e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.username) {
      setFormDataError({
        ...formDataError,
        nameError: toast.error("Name is required", {
          style: {
            backgroundColor: "red",
            color: "#fff",
          },
        }),
      });
    } else {
      setFormDataError({ ...formDataError });
    }
    if (!formData.email) {
      setFormDataError({
        ...formDataError,
        emailError: toast.error("Email is required", {
          style: {
            backgroundColor: "red",
            color: "#fff",
          },
        }),
      });
    } else if (
      !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(formData.email)
    ) {
      setFormDataError({
        ...formDataError,
        emailError: toast.error("Invalid email address", {
          style: {
            backgroundColor: "red",
            color: "#fff",
          },
        }),
      });
    } else {
      setFormDataError({ ...formDataError });
    }
    if (!formData.message) {
      setFormDataError({
        ...formDataError,
        messageError: toast.error("Message is required", {
          style: {
            backgroundColor: "red",
            color: "#fff",
          },
        }),
      });
    } else {
      setFormDataError({ ...formDataError });
    }

    if (username && email && message) {
      setLoading(true);
      emailjs
        .send(
          "service_zhwjmg6",
          "template_gvgy88r",
          {
            from_name: formData.username,
            to_name: "Hamdinou Mohamed lemine",
            from_email: formData.email,
            to_email: "leminlemin00@gmail.com",
            message: formData.message,
          },
          "mF-NBVB8etT-UXF-T"
        )
        .then(
          () => {
            setLoading(false);
            setIsFormSubmitted(true);

            // setFormData({
            //   name: "",
            //   email: "",
            //   message: "",
            // });
          },
          (error) => {
            setLoading(false);
            console.log(error);
          }
        );

      // const contact = {
      //   _type: "contact",
      //   name: username,
      //   email: email,
      //   message: message,
      // };

      // client.create(contact).then(() => {
      //   setLoading(false);
      //   setIsFormSubmitted(true);
      // });
    }
  };

  return (
    <>
      {!loading ? (
        <>
          <Toaster position="top-left" reverseOrder={true} />
          <h2 className="head-text dark:text-slate-50 ">
            Take a coffee &{" "}
            <span className="dark:bg-gradient-to-r from-[#007991] to-[#78ffd6]">
              chat with me
            </span>{" "}
          </h2>

          <div className="app__footer-cards">
            <div className="app__footer-card dark:bg-gray-800 bg-[#fef4f5] hover:drop-shadow-emailDropShadow dark:hover:drop-shadow-grayDropShadow transition-all">
              <img src={images.email} alt="email" />
              <a href="mailto:medlamine.hmd@gmail.com" className="p-text">
                medlamine.hmd@gmail.com
              </a>
            </div>
            <div className="app__footer-card dark:bg-darkthemealt bg-[#f2f7fb] hover:drop-shadow-phonedropShadow dark:hover:drop-shadow-altDropShadow transition-all">
              <img src={images.mobile} alt="phone" />
              <a href="tel:+1 (123) 456-7890" className="p-text">
                +1 (123) 456-7890
              </a>
            </div>
          </div>
          {!isFormSubmitted ? (
            <form className="app__footer-form app__flex">
              <div className="app__flex">
                <input
                  className="p-text dark:bg-darkthemealt dark:focus:text-slate-200 focus:drop-shadow-phonedropShadow dark:focus:drop-shadow-altDropShadow transition-all"
                  type="text"
                  placeholder="Your Name"
                  name="username"
                  value={username}
                  required
                  min={5}
                  max={50}
                  onChange={handleChangeInput}
                />
              </div>
              {/* {formDataError.nameError && <div>{formDataError.nameError}</div>} */}
              <div className="app__flex">
                <input
                  className="p-text dark:bg-darkthemealt dark:focus:text-slate-200 focus:drop-shadow-phonedropShadow dark:focus:drop-shadow-altDropShadow transition-all"
                  type="email"
                  placeholder="Your Email"
                  name="email"
                  value={email}
                  required
                  onChange={handleChangeInput}
                />
              </div>
              {/* {formDataError.emailError && (
                <div>{formDataError.emailError}</div>
              )} */}
              <div className="app__flex">
                <textarea
                  className="p-text dark:bg-darkthemealt dark:focus:text-slate-200 focus:drop-shadow-phonedropShadow dark:focus:drop-shadow-altDropShadow transition-all"
                  placeholder="Your Message"
                  value={message}
                  name="message"
                  required
                  minLength={50}
                  onChange={handleChangeInput}
                />
              </div>
              {/* {formDataError.messageError && (
                <div>{formDataError.messageError}</div>
              )} */}
              <button
                type="button"
                className="p-text bg-[#2188ff]  dark:bg-[#007991] hover:opacity-90 hover:drop-shadow-blueShadow dark:hover:drop-shadow-cyanShadow transition-all"
                onClick={handleSubmit}
              >
                {!loading ? "Send Message" : "Sending..."}
              </button>
            </form>
          ) : (
            <div>
              <h3 className="font-extrabold text-[2rem] md:text-[2.75rem] text-center capitalize dark:text-slate-50">
                <Typewriter
                  words={["Thank you for getting in touch!"]}
                  typeSpeed={100}
                  loop={1}
                  cursor
                  className="dark:text-slate-50"
                />
              </h3>
            </div>
          )}
        </>
      ) : (
        <>
          <div className="flex flex-col justify-center items-center h-screen dark:bg-darktheme ">
            <SyncLoader color={"#313cab"} loading={loading} size={15} />
          </div>
        </>
      )}
    </>
  );
};

export default AppWrap(
  MotionWrap(Footer, "app__footer"),
  "contact",
  "app__whitebg dark:bg-darktheme dark:transition-all"
);
